/* eslint-disable @typescript-eslint/ban-types */
import { Alert, Layout } from '@facile-it/shark-morph/components'
import * as Sentry from '@sentry/browser'
import * as React from 'react'

export class ErrorBoundary extends React.PureComponent<{ children?: React.ReactNode }, { hasError: boolean }> {
    constructor(props: {}) {
        super(props)
        this.state = { hasError: false }
    }

    componentDidCatch(error: Error | ErrorEvent | string, errorInfo: object) {
        this.setState({ hasError: true })
        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key])
            })
            Sentry.captureException(error)
        })
    }

    render() {
        if (this.state.hasError) {
            return (
                <Layout>
                    <Layout.Content>
                        <Alert type="danger">C&apos;è qualcosa che non va. Riprova più tardi.</Alert>
                    </Layout.Content>
                </Layout>
            )
        }

        return this.props.children
    }
}
